import { colors } from 'component-library/styles/colors';
import React, { HTMLProps } from 'react';
import styled, { css } from 'styled-components';

export const baseStyles = css<{ error?: boolean }>`
  color: ${colors.navyBlue};
  border: 2px solid ${({ error }) => (error ? colors.error : colors.navyBlue)};
  border-radius: 100px;
  padding: 16px 24px;
  font-size: 18px;
  height: 64px;
  margin-bottom: 8px;
  max-width: 100%;

  box-sizing: border-box;
  width: fit-content;

`;

const inputWidths = {
  0: '100px',
  1: '120px',
  2: '240px',
  3: '400px',
  4: '100%',
};

export interface TextInputProps
  extends Omit<
    HTMLProps<HTMLInputElement>,
    'as' | 'ref' | 'autoComplete' | 'onChange'
  > {
  error?: boolean;
  inputWidth?: keyof typeof inputWidths;
  onChange: (val: string) => void;
}

const StyledTextInput = styled.input.attrs({ autoComplete: 'off' })`
  ${baseStyles}
  width: ${({ inputWidth = 3 }: TextInputProps) => inputWidths[inputWidth]};

  // fixes issue with firefox input widths extending past the width of the screen
  min-width: 0;

  &:focus {
    outline: none;
  }

  ::placeholder {
    color: #999999;
    font-weight: lighter;
    font-size: 20px;
  }
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
`;

export const TextInput = React.forwardRef<unknown, TextInputProps>(
  ({ onChange, ...rest }, ref) => (
    <StyledTextInput
      {...rest}
      ref={ref as React.RefObject<HTMLInputElement>}
      onChange={(e) =>
        onChange &&
        onChange((e as React.ChangeEvent<HTMLInputElement>).target.value)
      }
    />
  ),
);
